module.exports = {
    /**
    * Handles and displays product quantity errors for custom box components.
    * Iterates through the provided data to identify products with errors or that have reached their maximum quota,
    * then displays appropriate error messages in the UI for each affected product.
    *
    * @param {Object} data - The data object containing the finalResults array with product information.
    * @param {Array} data.finalResults - Array of product result objects, each containing pid, message, error, and isMaxQuota.
    * @returns {void}
    */
    productQuantityError: function(data) {
        if (!data.finalResults.length) {
            let errorDescription = $(".custom-box-bar").data("box-max-qty-error");

            if ("message" in data && data.message) {
                errorDescription = data.message;
            }

            triggerErrorMessage(errorDescription);
            return;
        }

        // Search for products with errors
        const errorMessages = data.finalResults.map((item, index) => ({
            index: index,
            pid: item.pid,
            message: item.message,
            error: item.error,
            isMaxQuota: item.isMaxQuota
        })).filter(item => item.error || item.isMaxQuota);

        // Display errors
        errorMessages.forEach(function (item) {
            if (item.index === 0) {
                // Error message for main custom box product, it is first in the array
                triggerErrorMessage(item.message);
            } else {
                let $boxBarTile = $(".box-bar-tile[data-product-id='" + item.pid + "'");

                $boxBarTile.addClass("error-tile");
                $(".custom-box-bar .box-bar-error-message").remove();
                $boxBarTile.append("<div class='box-bar-error-message mx-auto'>" + item.message + "</div>");
            }
        });
    },
    /**
    * Reloads the current browser window after a 3-second delay.
    * Typically used to refresh the page following a user action or event.
    * @returns {number} The timeout ID that can be used to cancel the reload if needed.
    */
    windowReload: function() {
        return setTimeout(function () {
            // Redirect to Custom Boxes landing page
            location.reload();
        }, 3000);
    },
    /**
    * Closes the personalization modal dialog by triggering a click event on the close button.
    * Utilizes jQuery to select the close button within the personalization dialog and simulates a user click to close the modal.
    */
    closePersonalizationModal: function () {
        $(".personalization-dialog .personalization-close").trigger("click");
    },
    /**
    * Calculates and updates the displayed product price by adding the personalization fee to the base price.
    * Extracts numeric values from the DOM, supports both comma and dot as decimal separators, and preserves the original currency formatting.
    * Updates the price element in the DOM with the new total.
    *
    * @returns {void}
    */
    calculatePersonalizationPrice: function () {
        if (!$("#personalizationModal").hasClass("show")) {
            return;
        }

        var $personalization = $(".js-personalization-price");
        var $price = $(".js-price-value");

        var personalizationText = $personalization.text().trim();
        var priceText = $price.text().trim();

        // Extract numeric values (supports decimals with comma or dot)
        function extractNumber(text) {
            var number = text.replace(/[^0-9.,-]/g, "").replace(",", ".");
            return parseFloat(number) || 0;
        }

        var personalizationValue = extractNumber(personalizationText);
        var basePriceValue = extractNumber(priceText);

        var total = personalizationValue + basePriceValue;

        // Keep original currency format from base price
        var currencyBefore = priceText.match(/^[^\d-]+/); // currency before number
        var currencyAfter = priceText.match(/[^\d]+$/);   // currency after number

        var formattedTotal = total.toFixed(2);

        var newPrice =
            (currencyBefore ? currencyBefore[0] : "") +
            formattedTotal +
            (currencyAfter ? currencyAfter[0] : "");

        $price.text(newPrice);
    },
    /**
    * Sets and returns an error message for a trigger event.
    * @param {string} message - The error message to be displayed or processed.
    * @returns {*} - The result of the triggerErrorMessage function, typically the processed error message.
    */
    setTriggerErrorMessage: function (message) {
        return triggerErrorMessage(message);
    },
    /**
    * Disables the "Add to Cart" and "Personalize" buttons in the custom box UI.
    * Sets the "disabled" attribute to true for elements with the classes
    * ".js-add-to-cart-custom-box" and ".js-personalize" to prevent user interaction.
    */
    disableButtons: function () {
        $(".js-add-to-cart-custom-box").attr("disabled", true);
        $(".js-personalize").attr("disabled", true);
    },
    /**
    * Retrieves the selected quantity value from the currently visible personalization modal.
    * If no quantity is selected, defaults to "1".
    * @returns {string} The selected quantity value as a string, or "1" if not selected.
    */
    getModalQuantity: function () {
        const $modalQuantity = $(".c-personalization-modal.show select.quantity-select");

        if ($modalQuantity.length) {
            return $modalQuantity.val();
        } else {
            return "1";
        }
    }
};

/**
* Displays an error message after the custom box bar trigger element in the DOM.
* @param {string} message - The error message to display to the user.
*/
function triggerErrorMessage(message) {
    $(".custom-box-bar .custom-box-error-message").remove();
    $(".custom-box-bar-trigger").after("<div class='custom-box-error-message mx-auto'>" + message + "</div>");
}
